import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateWorksListComplianceDocsExportMutationMutationCgResponse,
  CreateWorksListComplianceDocsExportMutationMutationVariables,
} from '@common/graphql/schema/codegen-graphql';

export const CreateWorksListComplianceDocsExportMutation: TypedDocumentNode<
  CreateWorksListComplianceDocsExportMutationMutationCgResponse,
  CreateWorksListComplianceDocsExportMutationMutationVariables
> = gql`
  mutation CreateWorksListComplianceDocsExportMutation($worksListId: ID!) {
    createWorksListComplianceDocsExport(worksListId: $worksListId) {
      success
    }
  }
`;
